import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	actions: {
		id: 'admin-pages-issue-types-directory.table.body.actions.actions',
		defaultMessage: 'actions',
		description: 'Label for actions "more" button',
	},
	delete: {
		id: 'admin-pages-issue-types-directory.table.body.actions.delete',
		defaultMessage: 'Delete',
		description: 'Delete action button',
	},
	edit: {
		id: 'admin-pages-issue-types-directory.table.body.actions.edit',
		defaultMessage: 'Edit',
		description: 'Edit action button',
	},
	translate: {
		id: 'admin-pages-issue-types-directory.table.body.actions.translate',
		defaultMessage: 'Translate',
		description: 'Translate action button',
	},
});
